export default __webpack_public_path__ + "static/simple-pie-f4046c23439ccb6a2e343bade2d10d97.png";